import { ArrowDownTrayIcon, PaperAirplaneIcon } from '@heroicons/react/24/outline'
import { LayoutLoading } from 'components/LayoutLoading'
import { SendEmailDialog } from 'components/SendEmailDialog'
import { COMPANY_NAME_FC, ServicingEmail } from 'config'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { toast } from 'react-toastify'
import { downloadLoanIntakeDocs, getLoanIntakeDocumentData, sendLoanIntakeDocumentEmail } from 'services'
import { PlainTable } from 'stories/components'

interface ServicingDoc {
  name: string
  placeholders: string[]
  email: { subject: string; comment: string }
}

export function LoanIntakeDocument() {
  const { borrower } = useSelector((state: any) => ({
    borrower: state.borrower.borrower,
  }))
  const [loading, setLoading] = useState(true)
  const [documents, setDocuments] = useState<ServicingDoc[]>([])
  const [histories, setHistories] = useState<any[]>([])
  const [placeholders, setPlaceholders] = useState<any>({})
  const [docRlt, setDocRlt] = useState<any>({})
  const [currentDocument, setCurrentDocument] = useState<ServicingDoc | null>(null)
  const [missingPlaceholders, setMissingPlaceholders] = useState<any>([])

  const init = async () => {
    setLoading(true)

    const res = await getLoanIntakeDocumentData()
    if (res.success) {
      setDocuments(res.documents)
      setPlaceholders(res.placeholders)
      setDocRlt(res.docRlt)
      setHistories(res.histories)
    }
    setLoading(false)
  }

  useEffect(() => {
    init()
  }, [])

  const checkPlaceholders = (doc: ServicingDoc) => {
    let errors: any = []
    doc.placeholders.map((key) => {
      if (docRlt[key]?.length > 0) {
      } else {
        errors.push(placeholders[key] || key)
      }
    })
    errors = errors.sort()
    setMissingPlaceholders(errors)
    return true
  }

  const onDownload = (doc: ServicingDoc) => {
    // if (!checkPlaceholders(doc)) return
    setLoading(true)
    downloadLoanIntakeDocs(doc.name).finally(() => setLoading(false))
  }

  const onSendToBorrower = (doc: ServicingDoc) => {
    if (!checkPlaceholders(doc)) return
    setCurrentDocument(doc)
  }

  const onSendEmail = (emailData: Record<string, string>, data: Record<string, any>) => {
    if (!currentDocument) return
    return sendLoanIntakeDocumentEmail(currentDocument.name, emailData, data).then(() =>
      toast('Document is sent on email successfully.', { type: 'info' }),
    )
  }

  return (
    <div className="servicing-document-container">
      <div className="relative max-w-screen-2xl">
        <LayoutLoading show={loading} />
        <div className="overflow-auto mb-6">
          <table className="text-[15px] w-full">
            <thead>
              <tr>
                <th className="border p-2">No</th>
                <th className="border p-2">Document Name</th>
                <th className="border p-2">Actions</th>
              </tr>
            </thead>
            <tbody>
              {documents.map((item, index) => {
                return (
                  <tr key={index} className={`${index % 2 ? 'bg-gray-50' : ''}`}>
                    <td className="border p-2">{index + 1}</td>
                    <td className="border p-2">{item.name}</td>
                    <td className="border px-2 py-3">
                      <div className="flex flex-wrap gap-4">
                        <div
                          className="flex items-center gap-1 cursor-pointer hover:underline hover:text-shade-blue"
                          onClick={() => onDownload(item)}
                        >
                          Download
                          <ArrowDownTrayIcon className="w-4 h-3"></ArrowDownTrayIcon>
                        </div>
                        <div
                          className="flex items-center gap-1 cursor-pointer hover:underline hover:text-shade-blue"
                          onClick={() => onSendToBorrower(item)}
                        >
                          Send to Borrower
                          <PaperAirplaneIcon className="w-4 h-3"></PaperAirplaneIcon>
                        </div>
                      </div>
                    </td>
                  </tr>
                )
              })}
            </tbody>
          </table>
        </div>
        <div className="mb-4">
          <div className="border-b pl-2 pb-1">
            <div> History</div>
          </div>
          <PlainTable header={['No', 'Document', 'Emails', 'Date', 'By']} tdClass="px-4 py-2" data={histories} />
        </div>
        {currentDocument && (
          <SendEmailDialog
            title={`Send "${currentDocument.name}" Document`}
            data={[
              { party: 'Borrower', email: borrower.email },
              { party: `${COMPANY_NAME_FC} Servicing`, email: ServicingEmail },
            ]}
            emailData={currentDocument.email}
            defaultValues={{
              [borrower.email]: 'to',
              [ServicingEmail]: 'cc',
            }}
            onSubmit={onSendEmail}
            onClose={() => setCurrentDocument(null)}
            errors={missingPlaceholders}
          />
        )}
      </div>
    </div>
  )
}
